/**
 * Client-side filters and sorting for Camp Recipes browse UI.
 */
import { RECIPE_MAIN_PROTEINS } from './constants/communityRecipes';

/** Chips aligned with mockup game categories (maps to backend main_protein). */
export const RECIPE_GAME_CATEGORIES = [
  { id: 'all', label: 'All Game' },
  { id: 'venison', label: 'Venison' },
  { id: 'duck', label: 'Duck' },
  { id: 'turkey', label: 'Turkey' },
  { id: 'quail', label: 'Quail' },
  { id: 'rabbit', label: 'Rabbit' },
  { id: 'dove', label: 'Dove' },
  { id: 'squirrel', label: 'Squirrel' },
  { id: 'wild_boar', label: 'Wild Boar' },
];

const PROTEIN_ALIASES = {
  duck: ['duck', 'waterfowl'],
};

export function recipeSearchHaystack(recipe) {
  return [
    recipe?.title,
    recipe?.description,
    recipe?.main_protein_display,
    recipe?.main_protein,
    ...(Array.isArray(recipe?.main_vegetables) ? recipe.main_vegetables : []),
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
}

export function recipeMatchesCategory(recipe, categoryId) {
  if (!categoryId || categoryId === 'all') return true;
  const protein = (recipe?.main_protein || '').toLowerCase();
  const aliases = PROTEIN_ALIASES[categoryId] || [categoryId];
  return aliases.some((a) => protein === a || protein.includes(a));
}

export function filterRecipes(recipes, { searchQuery = '', categoryId = 'all' } = {}) {
  const q = searchQuery.trim().toLowerCase();
  return (recipes || []).filter((recipe) => {
    if (!recipeMatchesCategory(recipe, categoryId)) return false;
    if (q && !recipeSearchHaystack(recipe).includes(q)) return false;
    return true;
  });
}

export function sortRecipes(recipes, sortBy = 'popular') {
  const list = [...(recipes || [])];
  switch (sortBy) {
    case 'rating':
      return list.sort((a, b) => (b.avg_stars ?? 0) - (a.avg_stars ?? 0));
    case 'newest':
      return list.sort((a, b) => {
        const ta = a.created_at ? Date.parse(a.created_at) : 0;
        const tb = b.created_at ? Date.parse(b.created_at) : 0;
        return tb - ta;
      });
    case 'popular':
    default:
      return list.sort((a, b) => (b.rating_count ?? 0) - (a.rating_count ?? 0));
  }
}

/** Top-rated recipes with images for featured row (max 3). */
export function pickFeaturedRecipes(recipes, limit = 3) {
  return [...(recipes || [])]
    .filter((r) => r.thumbnail_url)
    .sort((a, b) => {
      const starDiff = (b.avg_stars ?? 0) - (a.avg_stars ?? 0);
      if (starDiff !== 0) return starDiff;
      return (b.rating_count ?? 0) - (a.rating_count ?? 0);
    })
    .slice(0, limit);
}

export function proteinLabel(value) {
  const row = RECIPE_MAIN_PROTEINS.find((p) => p.value === value);
  return row?.label || value || '';
}
